import { Component, Vue } from 'vue-property-decorator'

import Loader from '@/components/Loader/index.vue'
import FieldPortal from '@/components/edit/FieldPortal/index.vue'
import TableDeadlineDetail from '@/components/edit/TableDeadlineDetail/index.vue'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'

import { validationMixin } from 'vuelidate'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import vSelect from 'vue-select'
import fetch from '@/helpers/fetch'

library.add(faTrashAlt)

Vue.component('v-select', vSelect)

@Component({
	components: {
		Loader,
		FieldPortal,
		TableDeadlineDetail,
		MessageSuccess,
	},
	mixins: [validationMixin],
})
export default class ModalDeadline extends Vue {
	saving = null
	success = null

	get selectedDeadlineId() {
		return this.$store.state.deadlines.selectedDeadlineId
	}

	onSaving(on) {
		this.saving = on
	}

	onSuccess(on) {
		this.success = on
	}

	deletingTrigger = false
	onDeleteTrigger() {
		this.deletingTrigger = true
	}

	deleting = false
	async onConfirmInput($event) {
		const value = $event.target.value
		if (value.length === 8) {
			this.deleting = true

			const data = await fetch.delete(
				'/api/deadlines/' + this.selectedDeadlineId,
				{ password: value },
			)

			if (data && data.ok) {
				this.$bvModal.hide('modal-deadline')
				this.$emit('delete')
				this.deleting = false
				this.deletingTrigger = false
			} else {
				this.deleting = false
				this.deletingTrigger = false
			}
		}
	}
}
